// src/components/AdminPage.js
import React from 'react';
// import { Container } from 'react-bootstrap';
import NavBar from './AdminNavbar';

const Admin = () => {
  return (
    <div>
      <NavBar title="La'RIVERA INN" />
    </div>
    // <Container className="mt-5">
    //   <h1>Welcome, Admin!</h1>
    //   <p>This is the admin page where you can manage your content.</p>
    // </Container>
  );
};

export default Admin; // Ensure the default export
